import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-basket',
  styleUrls: ['./center.style.css'],
  template: `
    <div class="center">
      <svg 
        [style.cursor]="'pointer'" 
        (click)="onClick.emit()" 
        width="18" 
        height="20" 
        viewBox="0 0 18 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M17.25 3.5H0.75C0.551088 3.5 0.360322 3.57902 0.21967 3.71967C0.0790178 3.86032 0 4.05109 0 4.25C0 4.44891 0.0790178 4.63968 0.21967 4.78033C0.360322 4.92098 0.551088 5 0.75 5H1.5V18.5C1.5 18.8978 1.65804 19.2794 1.93934 19.5607C2.22064 19.842 2.60218 20 3 20H15C15.3978 20 15.7794 19.842 16.0607 19.5607C16.342 19.2794 16.5 18.8978 16.5 18.5V5H17.25C17.4489 5 17.6397 4.92098 17.7803 4.78033C17.921 4.63968 18 4.44891 18 4.25C18 4.05109 17.921 3.86032 17.7803 3.71967C17.6397 3.57902 17.4489 3.5 17.25 3.5ZM15 18.5H3V5H15V18.5ZM4.5 1.25C4.5 1.05109 4.57902 0.860322 4.71967 0.71967C4.86032 0.579018 5.05109 0.5 5.25 0.5H12.75C12.9489 0.5 13.1397 0.579018 13.2803 0.71967C13.421 0.860322 13.5 1.05109 13.5 1.25C13.5 1.44891 13.421 1.63968 13.2803 1.78033C13.1397 1.92098 12.9489 2 12.75 2H5.25C5.05109 2 4.86032 1.92098 4.71967 1.78033C4.57902 1.63968 4.5 1.44891 4.5 1.25Z" 
          fill="white" 
          fillOpacity="0.8" 
        />
      </svg>
    </div>`
})
export class BasketComponent {
  @Output() onClick = new EventEmitter<void>();
}
